import { DeliveryRequestItem } from '../../../../@types/model/deliveryRequest';
import { RefactoredDevice } from '../../../../@types/model/device';

const getIndexRemoveSlot = (
  device: RefactoredDevice,
  deliveryRequestItems: DeliveryRequestItem[]
) => {
  let ordinalToDelete = -1;
  let indexToDelete = -1;
  deliveryRequestItems.forEach((deliveryRequestItem: DeliveryRequestItem, index: number) => {
    let deviceGuid = device.guid;
    if (device.attributes.is_ref_of && device.attributes.is_ref_of.split(':').length === 3)
      deviceGuid = device.attributes.is_ref_of.split(':')[2];

    if (deliveryRequestItem.device === deviceGuid) {
      if ((deliveryRequestItem?.productScheduleItemOrdinal as number) > ordinalToDelete) {
        indexToDelete = index;
        ordinalToDelete = deliveryRequestItem.productScheduleItemOrdinal as number;
      }
    }
  });
  return indexToDelete;
};

export default getIndexRemoveSlot;
